module.exports = __webpack_public_path__ + "img/Copy-of-Wellwishers-(1)home.8cd77640.jpg";